import styled from 'styled-components';

import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';
import { theme } from '@/theme';

export const FiltersAppliedButtonList = styled(Flex)`
  overflow-x: scroll;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(1)};
  justify-content: flex-start;

  ${theme.media.md.up} {
    overflow-x: initial;
  }
`;

export const CloseIcon = styled(Icon)`
  display: flex;
  place-content: center;
  height: 13px;
  width: 13px;
  min-width: 13px;
`;
